import { ReactNode, createContext, Dispatch, SetStateAction } from 'react';

interface UserContextType {
	user: string;
	setUser: Dispatch<SetStateAction<string>>;
}
const userContext = createContext<UserContextType | undefined>(undefined);

export default userContext;

type ChildContainerProps = {
	children: ReactNode;
};

export type { ChildContainerProps, UserContextType };
